import * as React from "react"
import type { SVGProps } from "react"
const SvgDeviceLaptop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M1 20.57a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.42.29-.71a1 1 0 0 1 .71-.29h3v-1q-.82 0-1.41-.59A2 2 0 0 1 2 15.57v-10q0-.82.59-1.41A2 2 0 0 1 4 3.57h16q.83 0 1.41.59.6.59.59 1.41v10q0 .82-.59 1.41a2 2 0 0 1-1.41.59v1h3q.42 0 .71.29.3.29.29.71 0 .42-.29.71a1 1 0 0 1-.71.29zm3-5h16v-10H4z" />
  </svg>
)
export default SvgDeviceLaptop
